import React from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useGetRolesQuery, useDeleteRoleMutation } from "../../redux/api/rolesApi";

const RolesPage = () => {
  const { data: roles = [], isLoading, error } = useGetRolesQuery();
  const [deleteRole, { isLoading: isDeleting }] = useDeleteRoleMutation();

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this role?")) {
      try {
        await deleteRole(id).unwrap();
        toast.success('Role deleted successfully');
      } catch (err) {
        toast.error(err?.data?.message || err?.error || 'Failed to delete role');
      }
    }
  };

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div className="alert alert-danger">{error?.data?.message || error?.error || 'Failed to load roles'}</div>;

  return (
    <div>
      <h1 className="mb-4">Roles</h1>
      <Link to="/admin/roles/add" className="btn btn-primary mb-3">
        Add Role
      </Link>
      <div className="table-responsive">
        <table className="table table-bordered table-striped">
          <thead className="table-dark">
            <tr>
              <th>ID</th>
              <th>Role Name</th>
              <th>Description</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {roles.map((role) => (
              <tr key={role.role_id}>
                <td>{role.role_id}</td>
                <td>{role.role_name}</td>
                <td>{role.description}</td>
                <td>
                  <Link
                    to={`/admin/roles/${role.role_id}/edit`}
                    className="btn btn-sm btn-secondary me-2"
                  >
                    Edit
                  </Link>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => handleDelete(role.role_id)}
                    disabled={isDeleting}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RolesPage;
